export default "__VITE_ASSET__00e921ba__"